import React, {useState} from "react";
import {Button, Container, Overlay, Popover, Tooltip} from "react-bootstrap";

export const AddServiceHelper = ({company}) => {
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = React.useRef(null);

    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };

    return (
        <div ref={ref}>
            <Button onClick={handleClick} variant={"primary"}>Undrar du över QR-koden?</Button>
            {
                show ? <Container>
                        Ange texten såhär: "internt-FÖRETAG/TJÄNST"
                        <hr/>
                    För att vara på den säkra sidan, logga in på ett konto som tillhör {company} och säkerställ
                    att det det är korrekt.
                    </Container>
                    : null
            }
        </div>
    );
}
